import {
  GetPolicyAssignmentEligibleEmployeesDocument,
  GetPolicyAssignmentEligibleEmployeesQuery,
} from 'generated/resources/graphql'

import { useMemo } from 'modules/core/hooks/useMemo'
import { useQuery } from 'modules/core/hooks/useQuery'

const DELIMITER = '|'

export type PolicyAssignmentEligibleEmployee =
  GetPolicyAssignmentEligibleEmployeesQuery['contracts']['payrollPolicyAssignmentEligibleEmployeesConnection']['nodes'][0]

export const usePolicyAssignmentEligibleEmployees = (employeeIds: string[]) => {
  // This ensures the useQuery hook is only called when the employeeIds change value
  const joinedEmployeeIds = employeeIds.join(DELIMITER) ?? ''
  const memoizedEmployeeIds = useMemo(() => joinedEmployeeIds.split(DELIMITER), [joinedEmployeeIds])

  const { loading, data } = useQuery(GetPolicyAssignmentEligibleEmployeesDocument, {
    variables: { employeeIds: memoizedEmployeeIds },
    skip: !employeeIds.length,
  })

  const policyAssignmentEligibleEmployeeIds =
    data?.contracts?.payrollPolicyAssignmentEligibleEmployeesConnection?.nodes.map(
      (node) => node.employeeId
    )

  return {
    fetching: loading,
    policyAssignmentEligibleEmployeeIds,
  }
}
